import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '../../components/ui/tabs';
import { AcquireMetrics } from './tabs/AcquireMetrics';
import { EngageMetrics } from './tabs/EngageMetrics';
import { MeasureMetrics } from './tabs/MeasureMetrics';
import { ReputationMetrics } from './tabs/ReputationMetrics';
import { PageHeader } from '../../components/common/PageHeader';

type TabName = 'engage' | 'measure' | 'acquire' | 'reputation';

export const PartnerMetricsPage = () => {
  const { tab } = useParams<{ tab?: string }>();
  const navigate = useNavigate();

  // Initialize activeTab from URL parameter, default to 'engage'
  const [activeTab, setActiveTab] = useState<TabName>(() => {
    const validTabs: TabName[] = ['engage', 'measure', 'acquire', 'reputation'];
    return tab && validTabs.includes(tab as TabName)
      ? (tab as TabName)
      : 'engage';
  });

  // Handle URL changes (browser back/forward) - only when URL changes
  useEffect(() => {
    const validTabs: TabName[] = ['engage', 'measure', 'acquire', 'reputation'];
    const urlTab =
      tab && validTabs.includes(tab as TabName) ? (tab as TabName) : 'engage';

    if (urlTab !== activeTab) {
      setActiveTab(urlTab);
    }
  }, [tab, activeTab]);

  // Helper function to handle tab navigation
  const handleTabChange = (newTab: string) => {
    const validTabs: TabName[] = ['engage', 'measure', 'acquire', 'reputation'];
    if (!validTabs.includes(newTab as TabName)) return;

    const tabName = newTab as TabName;
    const currentPath = '/dashboard/metrics';
    const newPath =
      tabName === 'engage'
        ? `${currentPath}/engage`
        : `${currentPath}/${tabName}`;

    // Update both state and URL
    setActiveTab(tabName);
    navigate(newPath, { replace: true });
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Partner Metrics"
        description="View performance metrics across all EmbedReach products"
      />

      <Tabs
        value={activeTab}
        onValueChange={handleTabChange}
        className="space-y-6">
        <TabsList className="grid w-full max-w-2xl grid-cols-4">
          <TabsTrigger value="engage">Engage</TabsTrigger>
          <TabsTrigger value="measure">Measure</TabsTrigger>
          <TabsTrigger value="acquire">Acquire</TabsTrigger>
          <TabsTrigger value="reputation">Reputation</TabsTrigger>
        </TabsList>

        <TabsContent value="engage" className="space-y-6">
          <EngageMetrics />
        </TabsContent>

        <TabsContent value="measure" className="space-y-6">
          <MeasureMetrics />
        </TabsContent>

        <TabsContent value="acquire" className="space-y-6">
          <AcquireMetrics />
        </TabsContent>

        <TabsContent value="reputation" className="space-y-6">
          <ReputationMetrics />
        </TabsContent>
      </Tabs>
    </div>
  );
};
